// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/SegmentedControl/SegmentedControl.less
// module id = 231
// module chunks = 2